import { render } from "./IndexCourse.vue?vue&type=template&id=1839de4b"
import script from "./IndexCourse.vue?vue&type=script&lang=js"
export * from "./IndexCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__